import { useEffect } from "react"

interface UseObserverProps {
  ref: React.RefObject<Element | null>
  canLoad: boolean
  isLoading: boolean
  callback: () => void
  root?: Element | null
  threshold?: number
}

const useObserver = ({ ref, canLoad, isLoading, callback, root = null, threshold = 0.1 }: UseObserverProps) => {
  useEffect(() => {
    if (isLoading) return
    const element = ref.current
    if (!element) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        console.log(canLoad)
        if (entry.isIntersecting && canLoad) {
          console.log("Element visible to screen")
          callback()
        }
      },
      {
        root,
        threshold,
      }
    )

    observer.observe(element)

    return () => {
      if (element) observer.unobserve(element)
    }
  }, [isLoading, canLoad, callback, ref, root, threshold])
}

export default useObserver